import { render, staticRenderFns } from "./HomeWishlistBR.vue?vue&type=template&id=5e2982d3&scoped=true"
import script from "./HomeWishlistBR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2982d3",
  null
  
)

export default component.exports